import React, { createContext, useContext } from 'react'
import PropTypes from 'prop-types'

const DEFAULT_GUTTER_WIDTH = 30
const GutterWidthContext = createContext(DEFAULT_GUTTER_WIDTH)
const stylePropType = PropTypes.objectOf(
  PropTypes.oneOfType([PropTypes.number, PropTypes.string])
)

export const FluidGridContainer = React.forwardRef(
  ({ children, style = {}, ...props }, ref) => (
    <div
      ref={ref}
      style={{
        boxSizing: 'border-box',
        position: 'relative',
        marginLeft: 'auto',
        marginRight: 'auto',
        paddingLeft: DEFAULT_GUTTER_WIDTH / 2,
        paddingRight: DEFAULT_GUTTER_WIDTH / 2,
        ...style
      }}
      {...props}
    >
      {children}
    </div>
  )
)

FluidGridContainer.displayName = 'FluidGridContainer'
FluidGridContainer.propTypes = {
  children: PropTypes.node.isRequired,
  style: stylePropType
}

export const GridRow = React.forwardRef(
  (
    { children, gutterWidth = DEFAULT_GUTTER_WIDTH, style = {}, ...props },
    ref
  ) => (
    <div
      ref={ref}
      style={{
        marginLeft: -gutterWidth / 2,
        marginRight: -gutterWidth / 2,
        display: 'flex',
        flexGrow: 0,
        flexShrink: 0,
        alignItems: 'normal',
        justifyContent: 'flex-start',
        flexDirection: 'row',
        flexWrap: 'wrap',
        ...style
      }}
      {...props}
    >
      <GutterWidthContext.Provider value={gutterWidth}>
        {children}
      </GutterWidthContext.Provider>
    </div>
  )
)

GridRow.displayName = 'GridRow'
GridRow.propTypes = {
  children: PropTypes.node.isRequired,
  gutterWidth: PropTypes.number,
  style: stylePropType
}

export const FullWidthGridColumn = React.forwardRef(
  ({ children, style = {}, ...props }, ref) => {
    const gutterWidth = useContext(GutterWidthContext)

    return (
      <div
        ref={ref}
        style={{
          boxSizing: 'border-box',
          minHeight: 1,
          position: 'relative',
          paddingLeft: gutterWidth / 2,
          paddingRight: gutterWidth / 2,
          width: '100%',
          flexBasis: '100%',
          flexGrow: 0,
          flexShrink: 0,
          maxWidth: '100%',
          marginLeft: '0%',
          right: 'auto',
          left: 'auto',
          ...style
        }}
        {...props}
      >
        {children}
      </div>
    )
  }
)

FullWidthGridColumn.displayName = 'FullWidthGridColumn'
FullWidthGridColumn.propTypes = {
  children: PropTypes.node,
  style: stylePropType
}
